import { Tabs } from "@/components";
import { POLICY_CONFIG_TABS, POLICY_CONFIG_TAB_WORK_SCHEDULE_CONFIG } from "@/utils";
import { mapState } from "vuex";
import WorkScheduleConfig from "./components/WorkScheduleConfig/WorkScheduleConfig.vue";
export default {
  name: "PolicyConfig",
  components: { WorkScheduleConfig, Tabs },
  data() {
    return {
      policyConfigTabs: [],
      activeTab: POLICY_CONFIG_TAB_WORK_SCHEDULE_CONFIG,
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
  },
  created() {
    const { roles } = this.userInfo;
    this.policyConfigTabs = POLICY_CONFIG_TABS.filter((tab) => roles.find((role) => tab.roles.includes(role)));
  },
  methods: {
    handleChangeTab(key) {
      this.activeTab = key;
    },
  },
};
